export var FilterType;
(function (FilterType) {
    FilterType[FilterType["FileType"] = 0] = "FileType";
    FilterType[FilterType["Date"] = 1] = "Date";
    FilterType[FilterType["SharedBy"] = 2] = "SharedBy";
    FilterType[FilterType["Activity"] = 3] = "Activity";
    FilterType[FilterType["Tabs"] = 4] = "Tabs";
    FilterType[FilterType["Pill"] = 5] = "Pill";
    FilterType[FilterType["CustomPivot"] = 6] = "CustomPivot";
})(FilterType || (FilterType = {}));
export var CustomFilterType;
(function (CustomFilterType) {
    CustomFilterType["FileType"] = "FileType";
    CustomFilterType["Location"] = "Location";
    CustomFilterType["OwnedBy"] = "OwnedBy";
    CustomFilterType["SharedBy"] = "SharedBy";
    CustomFilterType["Pending"] = "Pending";
    CustomFilterType["Tag"] = "Tag";
    CustomFilterType["Tagv2"] = "Tagv2";
})(CustomFilterType || (CustomFilterType = {}));
//# sourceMappingURL=Filters.js.map